
export default {
  'VALUE_ID': {
    title: '存货分类编码',
    type: 'input',
    width: 120
  },
  'VALUE_KT': {
    title: '存货分类描述',
    type: 'input',
    width: 'auto'
  }
}




// WEBPACK FOOTER //
// ./src/components/dialog/config/Chfl.js